import type { DesgloseDetalle } from '@/lib/types';

function fmtAmount(n: number): string {
  return n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

/**
 * Desglose de charge codes como sub-filas (código · descripción · monto · moneda).
 * Si no hay detalle estructurado, cae al string concatenado (bookings viejos).
 */
export function DesgloseChargeCodes({
  detalle,
  fallback,
  label = 'Desglose',
}: {
  detalle?: DesgloseDetalle[] | null;
  fallback?: string | null;
  label?: string;
}) {
  if (detalle && detalle.length > 0) {
    return (
      <div className="mt-0.5">
        <span className="text-ink-600 font-medium">{label}:</span>
        <ul className="mt-0.5 ml-2 space-y-0.5">
          {detalle.map((d, i) => (
            <li key={`${d.code}-${d.currency}-${i}`} className="text-ink-500 flex gap-1">
              <span className="tabular font-medium text-ink-700">{d.code}</span>
              {d.description ? <span className="text-ink-500">— {d.description}</span> : null}
              <span className="tabular text-ink-700">
                ${fmtAmount(d.amount)} {d.currency}
              </span>
            </li>
          ))}
        </ul>
      </div>
    );
  }
  if (fallback) {
    return (
      <>
        {' '}
        <span className="text-ink-600 font-medium">{label}:</span>{' '}
        <span className="text-ink-500 tabular">{fallback}</span>
      </>
    );
  }
  return null;
}
